import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {KitchenType} from "../../property_configurator/types/KitchenType";
import {ConstructionEndDateType} from "./ConstructionEndDateType";
import {ForYouFloorChoiceType} from "./ForYouFloorChoiceType";

export interface IForYouAdditional {
    additional_areas: AdditionalAreaType | 0;
    kitchen: KitchenType | string;
    floor: ForYouFloorChoiceType[];
    date: ConstructionEndDateType;
    quarters: number[] | null;
    comments: string | null;
}

export enum ForYouAdditionalAreaType {
    BALCONY = "1",
    LOGGIA = "2",
    TERRACE = "3",
    GARDEN = "4"
}
import {AdditionalAreaType} from "../../property/utils/get_additional_area_type";
import {KitchenType} from "../../property_configurator/types/KitchenType";
import {ConstructionEndDateType} from "./ConstructionEndDateType";
import {ForYouFloorChoiceType} from "./ForYouFloorChoiceType";

export interface IForYouAdditional {
    additional_areas: AdditionalAreaType | 0;
    kitchen: KitchenType | string;
    floor: ForYouFloorChoiceType[];
    date: ConstructionEndDateType;
    quarters: number[] | null;
    comments: string | null;
}

export enum ForYouAdditionalAreaType {
    BALCONY = "1",
    LOGGIA = "2",
    TERRACE = "3",
    GARDEN = "4"
}
